export const LATINA_BASE_URL = process.env.REACT_APP_DOMAIN_V3
export const BOT_BASE_URL = process.env.REACT_APP_BOT_BASE_URL
